import React from 'react';
import moment from 'moment';
import { TextMessage, Text } from 'components/tt-forms/common';

class NhiemVuTTXM extends React.Component {
  render() {
    let ngayChuyen = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauTTXM).format('DD/MM/YYYY') : '';
    let tgBaoCao = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
    let yKien = this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.yKienCuaDonViGiaoTTXM : '';
    if (this.props.donInfo.laTTXMLai) {
      tgBaoCao = this.props.donInfo.ngayHetHanGiaiQuyetLanDau ? moment(this.props.donInfo.ngayHetHanGiaiQuyetLanDau).format('DD/MM/YYYY') : '';
      ngayChuyen = this.props.donInfo.ngayBatDauTTXMLanDau ? moment(this.props.donInfo.ngayBatDauTTXMLanDau).format('DD/MM/YYYY') : '';
      yKien = this.props.donInfo.noiDungYeuCauTTXMLanDau || '';
    }
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <div>
        <div className="box-items mb0">
          <div className="title">
            <div className="row pl10 pr10">
              <div className="col-12">
                <h3>Nhiệm vụ thẩm tra xác minh{lb2}</h3>
              </div>
            </div>
          </div>
          <div className="items-form mb0">
            <div className="row pl10 pr10 mb10">
              <Text
                className="col-25"
                label='Ngày chuyển:'
                value={ngayChuyen} />
              <Text
                className="col-25"
                label={'Đơn vị giao '+lb1+':'}
                value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ?
                this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViGiaoThamTraXacMinhInfo.ten : ''} />
              <Text
                red={true}
                className="col-25"
                label='Thời gian báo cáo kết quả:'
                value={tgBaoCao} />
            </div>
            <div className="row pl10 pr10">
              <TextMessage
                className="col-12"
                value={yKien}
                label={'Ý kiến xử lý của đơn vị giao '+lb1+':'} />
            </div>
          </div>
        </div>
        {
          this.props.donInfo.laTTXMLai ?
            <div className="box-items mb0 mt10">
              <div className="pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="title">
                <div className="row pl10 pr10">
                  <div className="col-12">
                    <h3>Nhiệm vụ thẩm tra xác minh{lb2} lại</h3>
                  </div>
                </div>
              </div>
              <div className="items-form mb0">
                <div className="row pl10 pr10 mb10">
                  <Text
                    className="col-25"
                    label='Ngày chuyển:'
                    value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayBatDauTTXM).format('DD/MM/YYYY') : ''} />
                  <Text
                    className="col-25"
                    label={'Đơn vị giao '+lb1+':'}
                    value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ?
                    this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViGiaoThamTraXacMinhInfo.ten : ''} />
                  <Text
                    red={true}
                    className="col-25"
                    label='Thời gian báo cáo kết quả:'
                    value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : ''} />
                </div>
                <div className="row pl10 pr10">
                  <TextMessage
                    className="col-12"
                    value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.yKienCuaDonViGiaoTTXM : ''}
                    label={'Ý kiến xử lý của đơn vị giao '+lb1+':'} />
                </div>
              </div>
            </div>
          :''
        }
      </div>
    );
  }
}
NhiemVuTTXM.defaultProps = {
  donInfo: {}
}

export default NhiemVuTTXM;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/NhiemVuTTXM.jsx